import Vue from 'vue'
import i18n from '@/i18n'

const vue = new Vue({ i18n })
export default [
    /*************************************************
    * Usuário 
    *************************************************/
    {
        path: '/controle-acesso/usuario',
        view: 'controle-acesso/usuario/Listar',
        meta:{
            title: vue.$t("Router.ControleAcesso.usuario")
        }    
    },
    {
        path: '/controle-acesso/usuario/adicionar',
        view: 'controle-acesso/usuario/Adicionar',
        meta:{
            title: vue.$t("Router.ControleAcesso.usuario")
        }    
    },    
    /*************************************************
    * Perfil 
    *************************************************/    
    {
        path: '/controle-acesso/perfil',
        view: 'controle-acesso/perfil/Listar',
        meta:{
            title: vue.$t("Router.ControleAcesso.perfil"),
        }    
    },                        
    /*************************************************
    * Aplicação 
    *************************************************/
    {
        path: '/controle-acesso/aplicacao',
        view: 'controle-acesso/aplicacao/Listar',
        meta:{
            title: vue.$t("Router.ControleAcesso.aplicacao")
        }    
    },
    {
        path: '/controle-acesso/aplicacao/adicionar',
        view: 'controle-acesso/aplicacao/Adicionar',
        meta:{
            title: vue.$t("Router.ControleAcesso.aplicacao")
        }    
    },
    {
        path: '/controle-acesso/aplicacao/editar/:id',
        view: 'controle-acesso/aplicacao/Editar',
        meta:{
            title: vue.$t("Router.ControleAcesso.aplicacao")
        }    
    },
    /*************************************************
    * Tipo Objeto 
    *************************************************/
    {
        path: '/controle-acesso/tipo-objeto',
        view: 'controle-acesso/tipo-objeto/Listar',
        meta:{
            title: vue.$t("Router.ControleAcesso.tipo-objeto")
        }    
    },
    {
        path: '/controle-acesso/tipo-objeto/adicionar',
        view: 'controle-acesso/tipo-objeto/Adicionar',
        meta:{
            title: vue.$t("Router.ControleAcesso.tipo-objeto")
        }    
    },
    {
        path: '/controle-acesso/tipo-objeto/editar/:id',
        view: 'controle-acesso/tipo-objeto/Editar',
        meta:{
            title: vue.$t("Router.ControleAcesso.tipo-objeto")
        }    
    },
    /*************************************************
    * Privilege 
    *************************************************/
    {
        path: '/controle-acesso/privilegio',
        view: 'controle-acesso/privilegio/Listar',
        meta:{
            title: vue.$t("Router.ControleAcesso.privilegio")
        }    
    },
    {
        path: '/controle-acesso/privilegio/adicionar',
        view: 'controle-acesso/privilegio/Adicionar',
        meta:{
            title: vue.$t("Router.ControleAcesso.privilegio")
        }    
    },
    {
        path: '/controle-acesso/privilegio/editar/:id',
        view: 'controle-acesso/privilegio/Editar',
        meta:{
            title: vue.$t("Router.ControleAcesso.privilegio")
        }    
    },
    /*************************************************
    * Menu 
    *************************************************/
    {
        path: '/controle-acesso/menu',
        view: 'controle-acesso/menu/Listar',
        meta:{
            title: vue.$t("Router.ControleAcesso.menu")
        }    
    },
    {
        path: '/controle-acesso/menu/adicionar',
        view: 'controle-acesso/menu/Adicionar',
        meta:{
            title: vue.$t("Router.ControleAcesso.menu")
        }    
    },
    {
        path: '/controle-acesso/menu/editar/:id',
        view: 'controle-acesso/menu/Editar',
        meta:{
            title: vue.$t("Router.ControleAcesso.menu")
        }    
    },
    /*************************************************
    * Recurso frontend 
    *************************************************/
    {
        path: '/controle-acesso/recurso-frontend',
        view: 'controle-acesso/recurso-frontend/Listar',
        meta:{
            title: vue.$t("Router.ControleAcesso.recurso-frontend")
        }    
    },
    {
        path: '/controle-acesso/recurso-frontend/adicionar',
        view: 'controle-acesso/recurso-frontend/Adicionar',
        meta:{
            title: vue.$t("Router.ControleAcesso.recurso-frontend")
        }    
    },
    {
        path: '/controle-acesso/recurso-frontend/editar/:id',
        view: 'controle-acesso/recurso-frontend/Editar',
        meta:{
            title: vue.$t("Router.ControleAcesso.recurso-frontend")
        }    
    },
    /*************************************************
    * Formulários
    *************************************************/
    {
        path: '/controle-acesso/formulario',
        view: 'controle-acesso/formulario/Listar',
        meta:{
            title: vue.$t("Router.ControleAcesso.formulario")
        }    
    },
    {
        path: '/controle-acesso/formulario/adicionar',
        view: 'controle-acesso/formulario/Adicionar',
        meta:{
            title: vue.$t("Router.ControleAcesso.formulario")
        }    
    },
    {
        path: '/controle-acesso/formulario/editar/:id',
        view: 'controle-acesso/formulario/Editar',
        meta:{
            title: vue.$t("Router.ControleAcesso.formulario")
        }    
    }   
]
